export default __webpack_public_path__ + "static/media/p13.15942a52.jpg";